module.exports = __webpack_public_path__ + "muli-webfont.97fc579a5e5ec79b9415.woff";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/src/assets/fonts/muli/muli-webfont.woff
// module id = ../../../../../src/assets/fonts/muli/muli-webfont.woff
// module chunks = styles